import {
  React,
  useState,
  Footer,
  useEffect,
  hostUrl,
  postRequestUnAuthenticated,
} from "../../globals/imports";
import PricingCard from "./widgets.js/PricingCard";
import { useSelector } from "react-redux";
import axios from "axios";

// Tier order for filtering: on the billing tab we show the current plan + only
// higher tiers (never downgrades). Public page (not logged in) shows all.
const PLAN_RANK = { free: 0, starter: 1, growth: 2, scale: 3 };

// const plans = [
//   {
//     _id: "free",
//     title: "Free Plan",
//     price: "₹0",
//     annualPrice: "₹0",
//     description: "Get started for free with all the community essentials",
//     buttonText: "Get started for free",
//     analyticTitle: "",
//     features: [
//       { name: "1 Channel", available: true },
//       { name: "Total 50 users", available: true },
//       { name: "Unlimited free events", available: true },
//       { name: "Auto Login", available: false },
//       { name: "Newsletters", available: false },
//       { name: "paid events", available: false },
//       { name: "Analytics", available: false },
//       { name: "Integration support", available: false },
//       { name: "Community Manager", available: false },
//       { name: "In App Notifications", available: false },
//       { name: "Chat summary", available: false },
//     ],
//   },
//   {
//     title: "Basic",
//     price: "₹249",
//     annualPrice: "₹2,499",
//     priceSuffix: "/month",
//     originalPrice: "₹299",
//     analyticTitle: "Basic Analytics",
//     originalAnnualPrice: "₹2,999",
//     description:
//       "Unlock powerful tools to grow, engage, and customise your community.",
//     buttonText: "Get started with Basic",
//     badge: "Limited time offer",
//     features: [
//       { name: "Up to 4 Channels", available: true },
//       { name: "Total 400 users", available: true },
//       { name: "paid events", available: false },
//       { name: "Auto Login", available: true },
//       { name: "5 monthly Newsletters", available: true },
//       {
//         available: true,
//         info: ["Total users", "Total chats", "Active users"],
//       },
//       { name: "Integration support", available: false },
//       { name: "Community Manager", available: false },
//       { name: "In App Notifications", available: false },
//       { name: "Chat summary", available: false },
//     ],
//   },
//   {
//     title: "Premium",
//     price: "₹449",
//     annualPrice: "₹4,499",
//     priceSuffix: "/month",
//     originalPrice: "₹599",
//     analyticTitle: "Advanced Analytics",
//     originalAnnualPrice: "₹5,499",
//     buttonText: "Get started with Premium",
//     description:
//       "Scale your community with advanced integrations and analytics.",
//     badge: "Limited time offer",
//     features: [
//       { name: "Up to 8 Communities", available: true },
//       { name: "Total 800 users", available: true },
//       { name: "paid events", available: true },
//       { name: "Auto Login", available: true },
//       { name: "10 monthly Newsletters", available: true },
//       {
//         available: true,
//         info: [
//           "Total users",
//           "Total chats",
//           "Active users",
//           "New joining users",
//           "Most active topic",
//           "Media shared count",
//         ],
//       },
//       { name: "Integration support", available: true },
//       { name: "Community Manager", available: true },
//       { name: "In App Notifications", available: true },
//       { name: "chat summary", available: true },
//     ],
//   },
//   {
//     title: "Enterprise",
//     price: "Custom pricing",
//     annualPrice: "Custom pricing",
//     analyticTitle: "Deep Analytics",
//     buttonText: "Talk to sales",
//     description:
//       "Get enterprise-grade features, security, and dedicated support.",
//     features: [
//       // { name: "Custom communities", available: true },
//       // { name: "Custom users", available: true },
//       // { name: "Unlimited free and paid events", available: true },
//       // { name: "Auto Login", available: true },
//       // { name: "Custom Newsletters", available: true },
//       {
//         available: true,
//         info: [
//           "Total users",
//           "Total chats",
//           "Active users",
//           "New joining users",
//           "Users interaction",
//           "Most interactive users",
//           "Inactive topics",
//           "Invites and joins",
//           "Most active topic",
//           "Media shared count",
//         ],
//       },
//       { name: "Dedicated support", available: true },
//       // { name: "Community Manager", available: true },
//       // { name: "In App Notifications", available: true },
//       // { name: "Custom solutions", available: true },
//       // { name: "Custom chat summary", available: true },
//     ],
//   },
// ];

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const business = useSelector((state) => state.business?.business);
  const activePlanId = business?.current_subscription?.planId;

  useEffect(() => {
    const fetchPlans = async () => {
      const response = await postRequestUnAuthenticated(`/get/plans`);
      setPlans(response.plans);
    };
    fetchPlans();
  }, []);

  // On the billing tab (subscribed), show the current plan + higher tiers only.
  // Elsewhere (public pricing, or no subscription) show every plan.
  const visiblePlans = (plans || []).filter((plan) => {
    if (!isLoggedIn || !activePlanId) return true;
    const current = PLAN_RANK[activePlanId] ?? 0;
    const rank = PLAN_RANK[plan._id] ?? 99;
    return rank >= current;
  });
  return (
    <div className="flex flex-col mt-20 items-center z-10 px-8 bg-theme-primaryBackground h-full ">
      <p className="text-theme-secondaryText text-2xl font-normal">
        Choose the plan that's right for you
      </p>
      <p className="mt-2 text-theme-primaryText text-xs font-extralight">
        No credit card required. You can cancel at any time.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-5xl mt-14 mx-auto">
        {visiblePlans.map((plan, index) => (
          <PricingCard key={index} plan={plan} type="monthly" />
        ))}
      </div>
      {/* Billing is a monthly auto-pay mandate (renews automatically each month
          until cancelled) — annual billing is temporarily disabled. */}
      <p className="mt-6 max-w-2xl text-center text-xs font-extralight text-theme-placeholder">
        Plans are billed monthly as an automatic-payment mandate — your
        subscription renews each month until you cancel. You can cancel anytime
        from your billing settings.
      </p>
      <div className="h-12"></div>
    </div>
  );
};

export default Pricing;
